angular.module( 'acme.view.application.pos.create.navigation', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.pos.create.navigation.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posCreateNavigation = {
        name: 'application.pos.create.navigation',
        url: '/navigation',
        views: {
          "subview-main": {
            controller: 'PosCreateNavigationController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/navigation/navigation.tpl.html'
          }
        },
        data: {
          pageTitle: 'Point of Sale Configurator'
        }
      },
      posEditNavigation = {
        name: 'application.pos.edit.navigation',
        url: '/navigation',
        views: {
          "subview-main": {
            controller: 'PosCreateNavigationController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/navigation/navigation.tpl.html'
          }
        },
        data: {
          pageTitle: 'Point of Sale Configurator'
        }
      };

    $stateProvider
      .state(posCreateNavigation)
      .state(posEditNavigation);
});
